// /src/mocks/usuarios.ts
import { IUsuario } from '../types';

export const mockUsuarios: IUsuario[] = [
  {
    id: 'user-1',
    nombre: 'Juan Administrador',
    email: 'admin@certificapro.com',
    rol: 'Admin',
  },
  {
    id: 'user-2',
    nombre: 'María Consultora',
    email: 'consultor@certificapro.com',
    rol: 'Consultor',
  },
  {
    id: 'user-3',
    nombre: 'Carlos Cliente',
    email: 'cliente@empresa1.com',
    rol: 'Cliente',
    empresaId: 'empresa-1',
  },
  {
    id: 'user-4',
    nombre: 'Ana Pérez',
    email: 'ana.perez@xyz.com',
    rol: 'Cliente',
    empresaId: 'empresa-2',
  },
  {
    id: 'user-5',
    nombre: 'Luis Martínez',
    email: 'luis@def.com',
    rol: 'Cliente',
    empresaId: 'empresa-3',
  },
  {
    id: 'user-6',
    nombre: 'Pedro Consultor',
    email: 'pedro.consultor@certificapro.com',
    rol: 'Consultor',
  },
  {
    id: 'user-7',
    nombre: 'Laura Administradora',
    email: 'laura.admin@certificapro.com',
    rol: 'Admin',
  },
];
